module.exports = "<div class=\"split-panel_wrapper\"></div>\n\n<!--<div class=\"js-resizer double-panels__resizer\"></div> !>";